import React, { useState, useEffect,useRef } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
import ErrorScreen from "../components/ErrorScreen";
import { useUser } from "../context/UserContext";
import AlertModal from "../components/AlertModal";
import { useAlertModal } from "../hooks/useAlertModal";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, A11y } from 'swiper/modules';

const roles = ["권한", "어드민", "본사", "부본사", "대리점"];
const games = ["게임"];
const statuses = ["상태", "활성", "비활성"];

const ApiManagement = () => {
  const { userInfo } = useUser(); // 로그인한 유저 정보
  const [apis, setApis] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isWebhookTabOpen, setWebhookTabOpen] = useState(false);
  const [selectedGames, setSelectedGames] = useState([]);
  const [filterRole, setFilterRole] = useState("전체");
  const [filterGame, setFilterGame] = useState("전체");
  const [filterStatus, setFilterStatus] = useState("전체");

  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [isCreateTabOpen, setCreateTabOpen] = useState(false);
const [searchUser, setSearchUser] = useState("");
const [filteredUsers, setFilteredUsers] = useState([]);
const [tempSelectedUser, setTempSelectedUser] = useState(null);
const [selectedRole, setSelectedRole] = useState("대리점");
const [gameOptions, setGameOptions] = useState([]); // 게임 목록

  const [scrollIndex, setScrollIndex] = useState(0);
  const sliderRef = useRef(null);
  const visibleCount = 3; // 한 화면에 보이는 아이템 개수 (필요에 따라 조절)

  const maxIndex = Math.max(0, games.length - visibleCount);
  const [selectedGameId, setSelectedGameId] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");

  const [webhookUrls, setWebhookUrls] = useState({
  member: '',
  bet: '',
  result: '',
  refund: '',
  balance: '',
});

  const filteredGames = gameOptions.filter((game) =>
    game.gameName.toLowerCase().includes(searchKeyword.toLowerCase())
  );

  const handleSelectGame = (game) => {
    setSelectedGameId(game.id);
  };

  const {
    isAlertOpen,
    alertMessage,
    showAlert,
    closeAlert
  } = useAlertModal();

  const fetchApi = async () => {
    
      setLoading(true);
      try {
        const res = await axios.get(`${API_BASE_URL}/game-api`, {
           headers: {
   
           'X-Frontend-Request': 'true',
      },
          params: { page, size: 10 },
        });
        setApis(res.data.content);
       // setApis([]);
        setTotalPages(res.data.totalPages);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    
  useEffect(() => {
    
    fetchApi();
  }, [page]);

  useEffect(() => {
  // 최초 로딩 시 검색어 없이 전체 리스트 가져오기
  const fetchInitialUsers = async () => {
    
    try {
      const res = await axios.get(`${API_BASE_URL}/admin/sub-agencies`, {
        params: { parentUsername: userInfo.username, keyword: "" },
        headers: { 'X-Frontend-Request': 'true' },
      });
      setFilteredUsers(res.data);
    } catch (error) {
      console.error("유저 검색 실패", error);
    }
  };

  fetchInitialUsers();
}, [userInfo.username]);



 const handleSearch = async (eOrValue) => {
  let value = "";
  if (typeof eOrValue === "string") {
    value = eOrValue;
  } else if (eOrValue && eOrValue.target) {
    value = eOrValue.target.value;
  }
  setSearchUser(value);

  try {
    const res = await axios.get(`${API_BASE_URL}/admin/sub-agencies`, {
      params: { parentUsername: userInfo.username, keyword: value },
      headers: { 'X-Frontend-Request': 'true' },
    });
    setFilteredUsers(res.data);
  } catch (error) {
    console.error("유저 검색 실패", error);
  }
};

useEffect(() => {
  handleSearch("");
}, [userInfo.username]);



const initWebhook  = async () => {
{
fetch(`${API_BASE_URL}/webhook`)
    .then((res) => res.json())
    .then((data) => {
    
      const urlMap = {};
      data.forEach(({ type, url }) => {
        urlMap[type] = url;
      });
      setWebhookUrls(urlMap);
    })
    .catch((err) => {
      console.error("웹훅 로딩 실패", err);
    })
  };
}

useEffect(() => {
  initWebhook();
}, []);

useEffect(() => {
  const fetchGames = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/games`, {
       params: { name: searchKeyword },
        headers: { 'X-Frontend-Request': 'true' },
      });
      setGameOptions(res.data.content);
    } catch (error) {
      console.error("게임 목록 불러오기 실패", error);
    }
  };
  fetchGames();
}, [searchKeyword]);

const handleCreateGameApi = async () => {
  if (!tempSelectedUser || !selectedGameId) return;

  try {
    await axios.post(`${API_BASE_URL}/game-api/create`, {
      adminUserId: tempSelectedUser.id,
      gameId: selectedGameId,
    }, {
      headers: {
        "Content-Type": "application/json",
        'X-Frontend-Request': 'true',
      },
    });

    setCreateTabOpen(false);
    setSelectedGames([]);
    setSearchUser("");
    setTempSelectedUser(null);
    fetchApi();
  } catch (error) {
    console.error("API 생성 실패", error);
    showAlert("API 생성에 실패했습니다.");
  }
};

const webhookFields = [
  { key: "회원 조회", icon: "👤", placeholder: "/webhook/member" },
  { key: "잔액 조회", icon: "💰", placeholder: "/webhook/balance" },
  { key: "베팅", icon: "🎲", placeholder: "/webhook/bet" },
  { key: "결과 처리", icon: "🏁", placeholder: "/webhook/result" },
  { key: "환불 처리", icon: "↩️", placeholder: "/webhook/refund" },
];

const isValidUrl = (url) => {
  const pattern = new RegExp(
    "^(https?:\\/\\/)?" +
    "((([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|" +
    "localhost|" +
    "\\d{1,3}(\\.\\d{1,3}){3})" +
    "(\\:\\d+)?(\\/[-a-zA-Z\\d%@_.~+&:]*)*" +
    "(\\?[;&a-zA-Z\\d%@_.,~+&:=-]*)?" +
    "(\\#[-a-zA-Z\\d_]*)?$",
    "i"
  );
  return !!pattern.test(url);
};

const handleSaveWebhook = async () => {
  const payload = webhookFields.map(({ key }) => ({
    type: key,
    url: webhookUrls[key] || "",
  }));

  // URL 유효성 검사
  for (const { type, url } of payload) {
    if (url && !isValidUrl(url)) {
       initWebhook();
    setWebhookTabOpen(false);
      showAlert(`❗️ '${type}' 항목에 입력된 URL 형식이 올바르지 않습니다.\n정확한 주소를 입력해 주세요.`);

      return;
    }
  }

  try {
    const res = await fetch(`${API_BASE_URL}/webhook`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const isSuccess = res.ok;

    if (isSuccess) {
      showAlert("✅ Webhook 설정이 정상적으로 저장되었습니다.");
    } else {

      showAlert("⚠️ Webhook 설정 저장에 실패하였습니다.\n잠시 후 다시 시도해 주세요.");
    }
  } catch (e) {
    showAlert("🚫 서버와의 통신 중 문제가 발생했습니다.\n네트워크 상태를 확인하거나 관리자에게 문의하세요.");
  } finally {
    initWebhook();
    setWebhookTabOpen(false);
  }
};

    // ✅ 게임 ON/OFF 상태 변경 함수
    const toggleActiveStatus = async (id) => {
      try {
        
        await fetch(`${API_BASE_URL}/game-api/${id}/toggle-status`, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            
           'X-Frontend-Request': 'true',
          },
        });
        setApis((prev) =>
          prev.map((api) =>
            api.id === id ? { ...api, active: !api.active } : api
          )
        );
      } catch (error) {
        console.error("토글 실패:", error);
      
      }
    };

    


// ✅ 필터링 적용
const filteredApis = (apis || []).filter((api) => {
  const role = api.adminUser?.adminType;
  const game = api.game?.gameName;

  const status = api.active;
  return (
    (filterRole === "전체" || role === filterRole) &&
    (filterGame === "전체" || game === filterGame) &&
    (filterStatus === "전체" || (filterStatus === "활성" ? status : !status))
  );
});

  if (loading) {
    return (
      <div className="loading-overlay">
        <div className="loader"></div>
      </div>
    );
  }
  if (error) return <ErrorScreen message={error} />;

  const handleCopy = async (text) => {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
    } else {
      // fallback for older browsers
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    }
    showAlert("API 키가 복사되었습니다.");
  } catch (err) {
    console.error("복사 실패:", err);
   
  }
  };

  return (
    <div id="container">
      <div className="container-inner">
    <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>
  <h2>API 키 관리</h2>
    {userInfo.adminType === "어드민" && (
  <button className="btn btn-add btn-webhook" onClick={() => setWebhookTabOpen(true)}>
    웹훅 설정
  </button>)}
</div>

        {/* ✅ 필터 영역 */}
            { 
            /* <div className="filters">
    
          <select value={filterRole} onChange={(e) => setFilterRole(e.target.value)}>
            {roles.map((role) => (
              <option key={role} value={role}>{role}</option>
            ))}
          </select>
          <select value={filterGame} onChange={(e) => setFilterGame(e.target.value)}>
            {games.map((game) => (
              <option key={game} value={game}>{game}</option>
            ))}
          </select>
         
          <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
            {statuses.map((status) => (
              <option key={status} value={status}>{status}</option>
            ))}
          </select> 
        </div>*/
        }
        {/* ✅ API 목록 */}

        
        <div className="api-list">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>권한 등급</th>
                <th>게임 이름</th>
                <th>API 키</th>
                <th>상태</th>
                {/* <th>API 활성화</th>*/}
              </tr>
            </thead>
            <tbody>
            { filteredApis.length > 0 ? (
                  <>
              {filteredApis.map((api) => (
                <tr key={api.id}>
                  <td>{api.adminUserName}</td>
                  <td>{api.adminUserType}</td>
                  <td>{api.gameType}</td>
                 <td>
                    <span title={api.apiKey} className="api-key">
                      {api.apiKey.slice(0, 35)}...
                    </span>
                    {/*
                    <button
                      className="copy-btn"
                      onClick={() => {navigator.clipboard.writeText(api.apiKey);showAlert("API 키가 복사되었습니다.");}}
                      title="복사"
                    >
                      📋
                    </button>*/

                     <button
                        className="copy-btn"
                        onClick={() => handleCopy(api.apiKey)}
                        title="복사"
                      >
                        📋
                      </button>
                   }

                  </td>
                  <td>
                      <button
                        className={`btn-toggle ${api.active ? "on" : "off"}`}
                        onClick={() => toggleActiveStatus(api.id)}
                      >
                        {api.active ? "활성화" : "비활성화"}
                      </button>
                  
                  </td>
                  {/*
                  <td>
                    <button className="btn-toggle" onClick={() => toggleMiniTab(api)}>
                      {api.status ? "비활성화" : "활성화"}
                    </button>
                  </td>*/}
                </tr>
              ))}</>):(<></>)}
            </tbody>
          </table>
        </div>

 
        { filteredApis.length > 0 ? (
                  <>

                        {userInfo.adminType === "어드민" && (
            <button
              className="btn-add"
              onClick={() => {
                setCreateTabOpen(true);
                setSearchKeyword("");
                setSearchUser("");
                setTempSelectedUser();
                handleSelectGame("");
              }}
            >
              +추가
            </button>
          )}

        {/* ✅ 페이지네이션 */}
        <div className="pagination">
        <button
              disabled={page === 0}
              onClick={() => setPage(page - 1)}
            >
              ◀
            </button>

            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i}
                className={i === page ? "active" : ""}
                onClick={() => setPage(i)}
              >
                {i + 1}
              </button>
            ))}

            <button
              disabled={page === totalPages - 1}
              onClick={() => setPage(page + 1)}
            >
              ▶
            </button>
        </div></>): (<>
            
            <div className="empty-state">
              <i className="fa-solid fa-key"></i>
              <p className="title">API 키가 존재하지 않습니다</p>
            </div>
            {userInfo.adminType === "어드민" && (
                    <button
                      className="btn-add"
                      onClick={() => {
                        setCreateTabOpen(true);
                        setSearchKeyword("");
                        setSearchUser("");
                        setTempSelectedUser();
                        handleSelectGame("");
                      }}
                    >
                      +추가
                    </button>
                  )}
            </>
        )
        
        }


     {isWebhookTabOpen && (
  <div className="mini-tab-overlay webhook-mini-tab-overlay">
    <div className="mini-tab webhook-mini-tab" onClick={(e) => e.stopPropagation()}>
      <div className="mini-tab-content webhook-mini-tab-content">
        <h3>Webhook 설정</h3>

      {
        webhookFields.map(({ key, icon, placeholder }) => (
          <div className="form-group webhook-input-group" key={key}>
            <label htmlFor={`webhook-${key}`} className="webhook-label">
              <span className="webhook-icon">{icon}</span> {key} URL
            </label>
            <input
              id={`webhook-${key}`}
              type="text"
              className="webhook-input"
              value={webhookUrls[key] || ""}
              onChange={(e) =>
                setWebhookUrls((prev) => ({
                  ...prev,
                  [key]: e.target.value,
                }))
              }
              placeholder={`http://example.com${placeholder}`}
            />
          </div>
        ))}

        <button className="btn btn-primary" onClick={handleSaveWebhook}>
          저장
        </button>
        <button
          className="btn btn-primary-outline"
          onClick={() => setWebhookTabOpen(false)}
        >
          닫기
        </button>
      </div>
    </div>
  </div>
)}

      {isCreateTabOpen && (
          <div className="mini-tab-overlay" >
            <div className="mini-tab" onClick={(e) => e.stopPropagation()}>
              <div className="mini-tab-content">
                <h3>Game API 생성</h3>

                {/* 관리자 검색 */}
                <input
                  type="text"
                  value={searchUser}
                  onChange={handleSearch}
                  placeholder="관리자 아이디 입력"
                />
                <ul>
                  {filteredUsers.length === 0 ? (
                    <li className="no-results">🔍 검색된 유저가 없습니다.</li>
                  ) : (
                    filteredUsers.map((user) => (
                      <li
                        key={user.id}
                        className={tempSelectedUser?.id === user.id ? "selected" : ""}
                        onClick={() => {
                          setSearchUser(user.username);
                          setTempSelectedUser(user);
                        }}
                      >
                        {user.username} ({user.adminType})
                      </li>
                    ))
                  )}
                </ul>  
                <h3></h3>
                   <h3>게임 리스트</h3>
                     <div class = "game-search-list">

                            <input
                  type="text"
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                  placeholder="게임 이름 입력"
                />
                 

                 {gameOptions.length === 0 ? (
                    <div className="no-results">❌ 등록된 게임이 없습니다.</div>
                  ) : (
                    <div className="swiper-wrapper">
                      <Swiper
                            modules={[Navigation, Pagination, A11y]}
                            spaceBetween={20}
                            slidesPerView={1}
                            loop={false}
                            navigation={{
                              nextEl: ".swiper-button-next",
                              prevEl: ".swiper-button-prev",
                            }}
                            pagination={{ clickable: true }}
                            grabCursor={true}        // ✅ 마우스 드래그 시 손 모양
                            touchStartPreventDefault={false} // ✅ 모바일 터치 충돌 방지
                            simulateTouch={true}     // ✅ 터치/마우스 드래그 활성화
                            style={{
                              WebkitOverflowScrolling: "touch",
                              scrollSnapType: "x mandatory",
                              padding: "20px",
                            }}
                          >
                        {gameOptions.map((game) => (
                          <SwiperSlide key={game.id}>
                            <div
                              className={`game-card ${selectedGameId === game.id ? "selected" : ""}`}
                              onClick={() =>{setSearchKeyword(game.gameName); handleSelectGame(game);}}
                            >
                              <div className="thumb">
                                <img
                                  src={`/assets/images/game_thumb${game.id}.png`}
                                  alt={game.gameName}
                                />
                              </div>
                              <div className="contents">
                                <p className="name">{game.gameName}</p>
                                <p className="text">{game.gameDescription}</p>
                              </div>
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>

                      {/* 🔽 미니멀한 화살표 */}
                      <div className="swiper-button-prev custom-arrow"></div>
                      <div className="swiper-button-next custom-arrow"></div>
                    </div>
                  )}
                </div>

                <button className="btn-primary" onClick={handleCreateGameApi}>
                  생성
                </button>
                <button
                  className="btn-primary-outline"
                  onClick={() => setCreateTabOpen(false)}
                >
                  닫기
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
       {isAlertOpen && <AlertModal message={alertMessage} onClose={closeAlert} />}
    </div>

    
  );
};

export default ApiManagement;